import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
// helpers
import { hotelPanelRootUrl, pagesUrl } from "../../utils/panel-helpers/helpers";

const PrivateEmployeesRoute = ({ children }: any) => {
  // states
  const employees = useSelector((state: any) => state.employees.employees);

  const isEditEmployeesAvailable = employees?.length > 0;

  if (isEditEmployeesAvailable) {
    return children;
  } else {
    return <Navigate to={`/${hotelPanelRootUrl}/${pagesUrl?.employees}`} />;
  }
};

export default PrivateEmployeesRoute;
